import Vue from "vue";
import Vuex from "vuex";
import vuexI18n from "vuex-i18n";
import en from "./src/en.json";
import th from "./src/th.json";
import la from "./src/la.json";
const store = new Vuex.Store();
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add("en", en);
Vue.i18n.add("th", th);
Vue.i18n.add("la", la);
Vue.i18n.set("en");

export default {};
